/* eslint-disable */
export default {
  _click: 'click',
  _eggs_revealed: 'eggs_revealed',
  _found_egg: 'found_egg',
  _found_egg1: 'found_egg1',
  _found_egg2: 'found_egg2',
  _found_egg3: 'found_egg3',
  _found_egg4: 'found_egg4',
  _game_over: 'game_over',
  _jingle: 'jingle',
  _level_completed: 'level_completed',
  _success: 'success',
  _woosh: 'woosh',
}